'use strict';

var Store = function(ResourceHelper, Flux, APP_DISPATCHER_ID, Pubnub, $location, $timeout) {

  // Intialize the store
  var SyncStore = Flux.Store.create({
    name: 'SyncStore',
    events: {
      Changed : true,
      ActiveSaved : true,
      LayerAdded : true,
      LayerRenamed : true
    }
  });

  /*

  Pubnub.init({
    publish_key: 'pub-c-7fc1bdf0-fa6f-406e-b95f-d5cc1a720200',
    subscribe_key: 'sub-c-998de48a-1ea4-11e6-b700-0619f8945a4f'
  });

  Pubnub.init({
    publish_key: 'pub-c-9ed32ec8-ac44-4c50-982c-dc1e5f8d7661',
    subscribe_key: 'sub-c-777f43a4-241a-11e6-84f2-02ee2ddab7fe'
  });

   */

  /**
   * Initial empty store state
   * @var {Object} $state
   */
  SyncStore.$state = {
    current: {}
  };

  /**
   * Intialize the store bindings and initial data.
   * @constructor
   */
  SyncStore.init = function() {
    // var d = Flux.Dispatcher.get(APP_DISPATCHER_ID);
  };

  SyncStore.subscribe = function(subKey, channel, callbacks) {
    var subscribers;
    if (!SyncStore.$state.current[subKey]) {
      Pubnub.getInstance(subKey).init({
        subscribe_key: subKey,
        ssl: $location.protocol() === 'https'
      });
      SyncStore.$state.current[subKey] = {};
    }

    subscribers = SyncStore.$state.current[subKey];

    if (subscribers[channel]) {
      return;
    }

    var options = {
      channel: channel
    };
    options.message = callbacks.message;
    $timeout(() => {
      Pubnub.getInstance(subKey).subscribe(options);
    }, 0);
  };

  return SyncStore;

};

Store.$inject = ['ResourceHelper', 'sbFlux', 'APP_DISPATCHER_ID', 'Pubnub', '$location', '$timeout'];
module.exports = Store;



// WEBPACK FOOTER //
// ./src/app/dash/dataStores/SyncStore.js